import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=31a8b7dc&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=31a8b7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8b7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a8b7dc')) {
      api.createRecord('31a8b7dc', component.options)
    } else {
      api.reload('31a8b7dc', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=31a8b7dc&scoped=true&", function () {
      api.rerender('31a8b7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4njsdLpCYcKIh/JS/comp/DateRange.vue"
export default component.exports